import React from 'react';
import PropTypes from 'prop-types';
import { WHITE } from '../config/colors';

function GridIcon({ color, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0"
      y="0"
      enableBackground="new 0 0 270 270"
      version="1.1"
      viewBox="0 0 270 270"
      xmlSpace="preserve"
      style={style}
    >
      <path
        fill={color || WHITE}
        d="M114 0H10C4.5 0 0 4.5 0 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10zm-10 104H20V20h84v84zM260 0H156c-5.5 0-10 4.5-10 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10zm-10 104h-84V20h84v84zM114 146H10c-5.5 0-10 4.5-10 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V156c0-5.5-4.5-10-10-10zm-10 104H20v-84h84v84zM260 146H156c-5.5 0-10 4.5-10 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V156c0-5.5-4.5-10-10-10zm-10 104h-84v-84h84v84z"
      />
    </svg>
  );
}

GridIcon.propTypes = {
  color: PropTypes.string.isRequired,
  style: PropTypes.objectOf({}).isRequired,
};

export default GridIcon;



// WEBPACK FOOTER //
// ./src/icons/GridIcon.jsx